import {
	// Loader,
	SaveCancelButtons,
	TableActionHeader,
} from 'components/Global';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import { FC, useEffect, useRef, useState } from 'react';
import { CHAT_MAPPING_RULE_EVENT, peekChatMappingRule } from 'utils/pendingChatMappingRule';
import { useDispatch, useSelector } from 'react-redux';
import { chartOfAccountAction } from 'redux/action/chartOfAccountAction';
import { classOptionsAction } from 'redux/action/classAction';
import {
	getConfiguration,
	updateConfiguration,
} from 'redux/action/configurationAction';
import { getConfigurationFieldAction } from 'redux/action/configurationFieldAction';
import {
	customerAccountAction,
	customerOptionsAction,
} from 'redux/action/customerAction';
import { getEmployeeCostAction } from 'redux/action/employeeCostAction';
import { getEmployeeCostColumnAction } from 'redux/action/employeeCostColumnSlice';
import { deleteApiWithData, getApi, postApi } from 'redux/apis';
import { AppDispatch } from 'redux/store';
import {
	checkPermission,
	createModifiedArray,
	isValidConfigurationSettings,
	toastText,
} from 'utils/utils';
import AllocationSettings from './AllocationSettings';
import ConfigurationSettings from './ConfigurationSettings';
import DecimalSettings from './DecimalSettings';
import ConfigurationHeader from './Header';
import styles from './index.module.scss';
import { ConfigurationsProps } from './types';
import { Tabs, Tooltip } from 'antd';
import JournalSettings from './JournalSettings';
import { CustomConfigurationMapping } from './CustomMappingRule';
import CompanySettings from './CompanySettings';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
	updateEmployeeExcludedFlag,
	updateJournalSummarizedViewFlag,
	updateTimeHoursDecimalFlag,
} from 'redux/action/companyAction';
import { SettingsChangeHandler } from './MappingBox/types';
import { cloneDeep } from 'lodash';
import {
	locationAction,
	locationOptionsAction,
} from 'redux/action/locationAction';
// Main component for configuration page
const Configurations: FC<ConfigurationsProps> = (props) => {
	// Inits
	const { setSelectedSidebar, closeDrawerByAnimation } = props;
	const dispatch = useDispatch<AppDispatch>();
	const configurationContainerRef = useRef<HTMLDivElement>(null);
	// const { isLoading, configurations: configurationsData } = useSelector(
	// 	(state: any) => state.companies
	// );

	const [updateConfigurationLoader, setUpdateConfigurationLoader] =
		useState(false);

	const [updateExcludeEmployeeLoader, setUpdateExcludeEmployeeLoader] =
		useState(false);

	const [updateSummarizedViewLoader, setUpdateSummarizedViewLoader] =
		useState(false);

	const [updateTimeHoursDecimalLoader, setUpdateTimeHoursDecimalLoader] =
		useState(false);

	const { isLoading, data: configurationsData } = useSelector(
		(state: any) => state?.configuration
	);

	// const { data: configurationsFieldData } = useSelector(
	// 	(state: any) => state?.configurationFields
	// );

	// useEffect(() => {
	// 	console.log('configurationsFieldData', configurationsFieldData);
	// });

	const { optionData: qbClass, isLoading: qbClassLoading } = useSelector(
		(state: any) => state?.class
	);
	const { data: qbChartOfAccounts, isLoading: qbChartOfAccountsLoading } =
		useSelector((state: any) => state.chartOfAccounts);
	const { optionData: qbCustomers, isLoading: qbCustomersLoading } =
		useSelector((state: any) => state.customer);
	const { optionData: qbLocations, isOptionLoading: qbLocationsLoading } =
		useSelector((state: any) => state.locations);
	const { selectedCompanyDetails } = useSelector(
		(state: any) => state.companies
	);

	const isConnected = useSelector(
		(state: any) => state.companies.selectedCompanyDetails?.company?.isConnected
	);
	const status = useSelector(
		(state: any) => state.companies.selectedCompanyDetails?.company?.status
	);

	const [isFirstTimeSubmit, setFirstTimeSubmit] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [configurationsDataCopy, setConfigurationsDataCopy] = useState(
		configurationsData?.settings
	);
	const [qbSelectionObj, setQbSelectionObj] = useState<any>({});
	const [payrollMethod, setPayrollMethod] = useState('Percentage');
	const [selectedItemDeleteData, setSelectedDelete] = useState<any>(null);
	const [indirectExpenseRate, setIndirectExpenseRate] = useState(
		configurationsData?.indirectExpenseRate
	);

	const [payPeriodId, setPayPeriodId] = useState<string | null>(null);

	const [decimalToFixedPercentage, setDecimalToFixedPercentage] = useState(
		configurationsData?.decimalToFixedPercentage
	);
	const [decimalToFixedAmount, setDecimalToFixedAmount] = useState(
		configurationsData?.decimalToFixedAmount
	);

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const [isClassRequiredForJournal, setIsClassRequiredForJournal] = useState(
		configurationsData?.isClassRequiredForJournal
	);
	const [isCustomerRequiredForJournal, setIsCustomerRequiredForJournal] =
		useState(configurationsData?.isCustomerRequiredForJournal);

	const [tabKey, setTabKey] = useState('1');

	// The AI chat hands a mapping rule off by navigating here
	// (?openDrawer=true&drawerSelection=Configurations) and leaving a pending
	// request — see utils/pendingChatMappingRule. The rules table that opens the
	// Add Rule modal lives under the Custom Mapping tab, so the drawer has to
	// select it or that table never mounts and the request sits unread.
	//
	// Peeked, never consumed: the table itself consumes it once its own data has
	// loaded. Consuming here would switch the tab and then drop the request.
	useEffect(() => {
		const selectCustomMappingTab = () => {
			if (peekChatMappingRule()) {
				setTabKey('4');
			}
		};
		selectCustomMappingTab();
		window.addEventListener(CHAT_MAPPING_RULE_EVENT, selectCustomMappingTab);
		return () => window.removeEventListener(CHAT_MAPPING_RULE_EVENT, selectCustomMappingTab);
	}, []);

	const showSaveButtonsKeys = ['1', '2', '3'];
	useEffect(() => {
		if (payPeriodId) {
			dispatch(
				getConfigurationFieldAction({
					payPeriodId,
				})
			);

			dispatch(
				getConfiguration({
					payPeriodId,
				})
			);
		}
	}, [payPeriodId]);

	// Migrate old allocation data to section 6 when data is loaded
	useEffect(() => {
		if (
			configurationsDataCopy &&
			Object.keys(configurationsDataCopy).length > 0
		) {
			const hasSection6 =
				configurationsDataCopy['6'] &&
				Object.keys(configurationsDataCopy['6'].fields).length > 0;

			// If we have no section 6, always create a default allocation
			if (!hasSection6) {
				const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));

				// Ensure section 6 exists
				if (!tempCopy['6']) {
					tempCopy['6'] = {
						id: '6',
						type: 'allocationRates',
						fields: {},
						addMore: true,
						toolTip:
							'Define multiple allocations rates, each with its own Account, Customer, Class, Location and Rate.',
						placeHolder: 'Select values',
						errorMessage: 'Please complete all fields for allocation rates.',
						qbMappingValue: '',
						capMappingTitle: 'Allocation Rates',
					};
				}

				// Migrate existing data if available, otherwise create default
				const account = tempCopy['4']?.fields?.['f1']?.value;
				const customer = tempCopy['5']?.fields?.['f1']?.value;
				const classValue = tempCopy['0']?.fields?.['f2']?.value;

				// Always create a default allocation with "Indirect Rate" label
				tempCopy['6'].fields['f1'] = {
					id: 'f1',
					label: 'Indirect Rate',
					account: account || null,
					customer: customer || null,
					class: classValue || null,
					location: null,
					rate: 0,
					editable: true,
					deletable: true,
					isEditing: false,
					isActive: true,
					priority: 1,
				};

				setConfigurationsDataCopy(tempCopy);
			}
		}
	}, [configurationsDataCopy]);

	const [importStatus, setImportStatus] = useState(
		localStorage.getItem('importStatus')
	);

	const openNotification = () => {
		toastText(
			'Employee cost imported successfully. Please review your GL accounts mapping, then click "Save & Close" to continue.',
			'info',
			10000
		);
		setImportStatus('false');
		localStorage.setItem('importStatus', 'false');
	};

	if (importStatus == 'true') {
		openNotification();
	}
	// for handle the any of the settings change
	// const settingsChangeHandler = (settingsChangeData: SettingsChangeHandler) => {
	// 	const { sectionId, dataId, fieldId, fieldName } = settingsChangeData;
	// 	const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));
	// 	tempCopy[sectionId].fields[fieldId][fieldName] = dataId;
	// 	setConfigurationsDataCopy(tempCopy);
	// };

	// Updated for handle the any of the settings change
	const settingsChangeHandler = (settingsChangeData: SettingsChangeHandler) => {
		const { sectionId, dataId, fieldId, fieldName } = settingsChangeData;
		// Create a temporary copy of the configurations data to modify
		const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));

		// Ensure the section exists before trying to access it
		if (!tempCopy[sectionId]) {
			// Create the section if it doesn't exist (for section 6)
			if (sectionId === '6') {
				tempCopy[sectionId] = {
					id: sectionId,
					type: 'allocationRates',
					fields: {},
					addMore: true,
					toolTip:
						'Define multiple allocations rates, each with its own Account, Customer, Class, Location and Rate.',
					placeHolder: 'Select values',
					errorMessage: 'Please complete all fields for allocation rates.',
					qbMappingValue: '',
					capMappingTitle: 'Allocation Rates',
				};
			}
		}

		// Ensure the field exists before trying to access it
		if (!tempCopy[sectionId].fields[fieldId] && sectionId === '6') {
			// Create the field if it doesn't exist
			tempCopy[sectionId].fields[fieldId] = {
				id: fieldId,
				label: 'Indirect Rate',
				account: null,
				customer: null,
				class: null,
				location: null,
				rate: 0,
				editable: true,
				deletable: true,
				ratesLimited: false,
				isEditing: false,
				isActive: true,
				priority: Object.keys(tempCopy[sectionId].fields).length + 1,
			};
		}

		// Check if there is already a field with the same name in the section
		const sectionFields = tempCopy[sectionId]?.fields || {};
		if (typeof dataId === 'string' && dataId.trim() !== '') {
			const duplicateField = Object.values(sectionFields).some(
				(field: any) =>
					field?.label.toLowerCase().trim() === dataId?.toLowerCase().trim() &&
					field?.id !== fieldId // Check fieldName and ensure we're not comparing the same field
			);

			if (duplicateField) {
				// If duplicate is found, you can show a warning or handle it differently
				toastText(
					'Duplicate field name detected! Please choose a different name',
					'info',
					2000
				);
				tempCopy[sectionId].fields[fieldId][fieldName] = dataId + ' Copy';
				setConfigurationsDataCopy(tempCopy);
				return; // Exit early to prevent updating the field
			}
		}

		const value =
			typeof dataId === 'string' ? dataId.trim() : dataId;

		// If no duplicate is found, proceed with the settings change
		tempCopy[sectionId].fields[fieldId][fieldName] = value;
		setConfigurationsDataCopy(tempCopy);
	};

	// For generate the appropriate mapping for QBclass and QBCustomer, QBChatOfAccount
	const generateMappingObject = () => {
		const quickBookClass = qbClass?.map((singleClass: any) => {
			return { ...singleClass, isDisable: false };
		});
		const quickBookCustomers = qbCustomers?.map((singleClass: any) => {
			return { ...singleClass, isDisable: false };
		});
		const quickBookChartOfAccounts = qbChartOfAccounts?.map(
			(singleClass: any) => {
				return { ...singleClass, isDisable: false };
			}
		);

		const quickBookLocations = qbLocations?.map((singleLocation: any) => {
			return { ...singleLocation, isDisable: false };
		});

		const _classList = configurationsDataCopy
			? createModifiedArray(
				quickBookClass,
				configurationsDataCopy[0].fields['f1'].value
			)
			: quickBookClass;
		// _classList = configurationsDataCopy
		// 	? createModifiedArray(
		// 		_classList,
		// 		configurationsDataCopy[0].fields['f2'].value
		// 	)
		// 	: _classList;

		setQbSelectionObj({
			qbCoa: quickBookChartOfAccounts,
			qbCustomer: quickBookCustomers,
			qbClass: _classList,
			qbLocation: quickBookLocations,
		});
	};

	// For handle the payroll method change type
	const changePayrollMethodHandler = (selectedPayrollMethod: string) => {
		setPayrollMethod(selectedPayrollMethod);
	};

	// For handle the expanse rate
	const changeExpenseRateAllocationHandler = (e: any) => {
		setIndirectExpenseRate(e);
	};

	// For set the default value for the selected payroll method and indirect expense
	const handleInitialState = () => {
		setConfigurationsDataCopy(configurationsData?.settings);
		setPayrollMethod(configurationsData?.payrollMethod);
		setIndirectExpenseRate(configurationsData?.indirectExpenseRate);
		setDecimalToFixedAmount(configurationsData?.decimalToFixedAmount);
		setDecimalToFixedPercentage(configurationsData?.decimalToFixedPercentage);
		setIsClassRequiredForJournal(configurationsData?.isClassRequiredForJournal);
		setIsCustomerRequiredForJournal(
			configurationsData?.isCustomerRequiredForJournal
		);
	};

	const validateSection6 = (configurationsDataCopy: any) => {
		if (
			!configurationsDataCopy['6'] ||
			Object.keys(configurationsDataCopy['6'].fields).length === 0
		) {
			return { isValid: true, remainingId: null }; // No section 6 fields to validate
		}

		const section6Fields: any = Object.values(
			configurationsDataCopy['6'].fields
		);

		// Calculate total allocation percentage
		const totalAllocation = section6Fields.reduce(
			(total: number, field: any) => {
				return total + (field.rate || 0);
			},
			0
		);

		// Check if total allocation exceeds 100%
		if (totalAllocation > 100) {
			return {
				isValid: false,
				remainingId: null,
				message: 'Total allocation cannot exceed 100%',
			};
		}

		// Check if there's only one allocation row
		const isSingleAllocation = section6Fields.length === 1;

		for (const field of section6Fields) {
			// Check if any field is still in editing mode
			if (field.isEditing) {
				return {
					isValid: false,
					remainingId: `6${field.id}`,
					message: 'Please complete editing all indirect allocation fields',
				};
			}

			// Check if label is empty
			if (!field.label || field.label.trim() === '') {
				return {
					isValid: false,
					remainingId: `6${field.id}`,
					message: 'Please enter a name for all indirect allocations',
				};
			}

			// For single allocation, make account, customer, and class optional
			// For multiple allocations, these fields are required
			if (!isSingleAllocation || (isSingleAllocation && field.rate > 0)) {
				// Check if required fields are selected (account, customer, class) - only when multiple allocations
				if (!field.account) {
					return {
						isValid: false,
						remainingId: `6${field.id}`,
						message: 'Please select an account for all allocations rates',
					};
				}

				if (!field.customer) {
					return {
						isValid: false,
						remainingId: `6${field.id}`,
						message: 'Please select a customer for all allocations rates',
					};
				}

				if (!field.class) {
					return {
						isValid: false,
						remainingId: `6${field.id}`,
						message: 'Please select a class for all allocations rates',
					};
				}
			}

			// Check if rate is valid (optional, but if present should be >= 0)
			if (field.rate < 0) {
				return {
					isValid: false,
					remainingId: `6${field.id}`,
					message: 'Rate cannot be negative',
				};
			}
		}

		return { isValid: true, remainingId: null };
	};
	// For save the configuration
	const saveConfigurationHandler = async () => {
		setUpdateConfigurationLoader(true);
		try {
			const response = await getApi('/configuration', {
				companyId: localStorage.getItem('companyId'),
				payPeriodId,
			});
			const configurationFields = response.data.data;

			await dispatch(
				getConfigurationFieldAction({
					payPeriodId,
				})
			);
			setFirstTimeSubmit(false);
			const { isValidSelectBox, isAddEditFalse, isBlankLabel, remainingId } =
				isValidConfigurationSettings(
					configurationsDataCopy,
					indirectExpenseRate
				);
			const section6Validation = validateSection6(configurationsDataCopy);
			if (remainingId) {
				const el = document.getElementById(remainingId) as HTMLElement;
				el?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
					inline: 'nearest',
				});
				// el.focus();
			}
			if (!isValidSelectBox) {
				toastText('Please select valid Quickbook details', 'error');
				return;
			}
			if (!section6Validation.isValid) {
				console.error('Section 6 validation failed:', section6Validation);
				// Show error message based on the validation result
				toastText(
					section6Validation.message ||
					'Please complete all allocation rate fields',
					'error'
				);
				if (section6Validation.remainingId) {
					const el = document.getElementById(
						section6Validation.remainingId
					) as HTMLElement;
					if (el) {
						el.scrollIntoView({
							behavior: 'smooth',
							block: 'center',
							inline: 'nearest',
						});
					}
				}
				return;
			}

			if (!isAddEditFalse) {
				toastText('Please complete the editing of columns first', 'error');
				return;
			}

			if (isBlankLabel) {
				toastText('Please enter the valid column name', 'error');
				return;
			}

			// FOR ADD THE FIELD  IN SQL
			if (isValidSelectBox && isAddEditFalse && !isBlankLabel) {
				// let finalChanges: any = [];

				const newObject = Object.values(configurationsDataCopy);
				const fieldsObject: any = {};

				for (const singleSection of configurationFields) {
					const fieldArray = singleSection.fields.map(
						(singleField: any) => singleField.jsonId
					);
					fieldsObject[singleSection.no] = fieldArray;
				}
				const newSqlObject: any = {};

				for (const singleSection of newObject as any) {
					const data = Object.values(singleSection.fields).filter(
						(singleField: any) => {
							if (fieldsObject?.[singleSection?.id]) {
								if (
									!fieldsObject?.[singleSection?.id]?.includes(singleField.id)
								) {
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						}
					);
					const sqlSection: any = configurationFields.find(
						(sqlSingleSection: any) => sqlSingleSection.no == singleSection.id
					);
					if (sqlSection?.id && data.length > 0) {
						newSqlObject[sqlSection.id] = data;
					}
				}

				// FOR DELETE THE FIELD IN SQL
				const deleteFieldObject: any = {};
				const deleteSqlSection: any = [];
				for (const [
					index,
					singleSection,
				] of configurationFields.entries() as any) {
					if (index !== 0) {
						const fieldArray: any = [];
						for (const singleField of singleSection.fields) {
							if (singleField.jsonId.charAt(0) === 'f') {
								fieldArray.push(singleField.jsonId);
							}
						}
						deleteFieldObject[singleSection.no] = fieldArray;
					}
				}

				for (const singleSection of newObject as any) {
					if (deleteFieldObject?.[singleSection?.id]) {
						for (const field of Object.values(singleSection.fields) as any) {
							const index = deleteFieldObject[singleSection.id].indexOf(
								field.id
							);
							if (index >= 0) {
								deleteFieldObject[singleSection.id].splice(index, 1);
							}
						}
					}
				}

				for (const section of configurationFields) {
					if (deleteFieldObject[section.no]) {
						const ids = deleteFieldObject[section.no];
						if (ids.length > 0) {
							const fields = section.fields.filter((singleField: any) =>
								deleteFieldObject[section.no].includes(singleField.jsonId)
							);
							for (const singleMyField of fields as any) {
								deleteSqlSection.push(singleMyField.id);
							}
						}
					}
				}

				// for (const singleSection of configurationFields) {
				// 	const data = singleSection.fields.filter((singleField) => {});
				// }

				let isDeleteAllSuccessful = false;
				let isPostAllSuccessful = true;

				try {
					await deleteApiWithData('/configuration/bulk-delete', {
						listOfFieldIds: deleteSqlSection,
						companyId: localStorage.getItem('companyId'),
						payPeriodId,
					});
					isDeleteAllSuccessful = true;
				} catch (error) {
					console.error('API Error:', error);
				}

				const finalArr: any = [];

				Object.entries(newSqlObject).forEach((singleItem: any) => {
					const data = singleItem[1].map((item: any) => {
						return {
							sectionId: singleItem[0],
							jsonId: item?.id,
							name: item?.label,
							payPeriodId,
						};
					});
					finalArr.push(...data);
				});

				// Call configuration create api for field creation
				for (const singleField of finalArr) {
					try {
						await postApi('/configuration', {
							companyId: localStorage.getItem('companyId'),
							sectionId: singleField?.sectionId,
							name: singleField?.name,
							jsonId: singleField?.jsonId,
							payPeriodId,
							priority: singleField?.priority || 0,
						});
						// return response;
					} catch (err) {
						isPostAllSuccessful = false;
						console.error('API Error:', err);
					}
				}
				// const promises = finalArr.map(async (singleField: any) => {
				// });

				// await Promise.all(promises);
				if (isDeleteAllSuccessful && isPostAllSuccessful) {
					// Sync first indirect allocation to old fields for backward compatibility
					const syncIndirectAllocationToOldFields = (settingsData: any) => {
						const copy = cloneDeep(settingsData);

						// If section 6 exists and has fields, sync the first one to old fields for backward compatibility
						if (copy['6'] && Object.keys(copy['6'].fields).length > 0) {
							// Get the first indirect allocation (sorted by priority)
							const firstAllocation: any = Object.values(copy['6'].fields).sort(
								(a: any, b: any) => a.priority - b.priority
							)[0];

							// Sync to old fields for backward compatibility
							if (copy['4'] && copy['4'].fields && copy['4'].fields['f1']) {
								copy['4'].fields['f1'].value = firstAllocation.account;
							}
							if (copy['0'] && copy['0'].fields && copy['0'].fields['f2']) {
								copy['0'].fields['f2'].value = firstAllocation.class;
							}
						} else {
							// If section 6 is empty, preserve the existing single allocation values
							// This ensures backward compatibility when section 6 isn't being used
							const account = copy['4']?.fields?.['f1']?.value;
							const customer = copy['5']?.fields?.['f1']?.value;
							const classValue = copy['0']?.fields?.['f2']?.value;

							// If there are values in the old fields but no section 6, create section 6 with these values
							if (
								(account || customer || classValue) &&
								(!copy['6'] || Object.keys(copy['6'].fields).length === 0)
							) {
								if (!copy['6']) {
									copy['6'] = {
										id: '6',
										type: 'allocationRates',
										fields: {},
										addMore: true,
										toolTip:
											'Define multiple allocations rates, each with its own Account, Customer, Class, Location and Rate.',
										placeHolder: 'Select values',
										errorMessage:
											'Please complete all fields for allocation rates.',
										qbMappingValue: '',
										capMappingTitle: 'Allocation Rates',
									};
								}

								copy['6'].fields['f1'] = {
									id: 'f1',
									label: 'Indirect Rate',
									account: account || null,
									customer: customer || null,
									class: classValue || null,
									location: null,
									rate: indirectExpenseRate || 0,
									editable: true,
									deletable: true,
									isEditing: false,
									isActive: true,
									priority: 1,
								};
							}
						}

						return copy;
					};

					const dataToSave = syncIndirectAllocationToOldFields(
						configurationsDataCopy
					);

					await dispatch(
						updateConfiguration({
							settings: dataToSave,
							indirectExpenseRate: Number(indirectExpenseRate.toFixed(2)),
							payrollMethod: payrollMethod,
							decimalToFixedAmount: Number(decimalToFixedAmount),
							decimalToFixedPercentage: Number(decimalToFixedPercentage),
							isClassRequiredForJournal,
							isCustomerRequiredForJournal,
							payPeriodId,
						})
					);

					configurationContainerRef.current?.scrollTo({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});

					await dispatch(
						getEmployeeCostColumnAction({
							payPeriodId,
						})
					)
						.unwrap()
						.then(() => {
							//
						});

					await dispatch(
						getEmployeeCostAction({
							payPeriodId,
						})
					);

					// localStorage.removeItem('settings');
					window.location.reload();
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setUpdateConfigurationLoader(false);
		}
	};
	// For reset the configuration
	const cancelConfigurationHandler = () => {
		setFirstTimeSubmit(true);
		setConfigurationsDataCopy(configurationsData.settings);
		handleInitialState();
	};

	//delete fieldHandler
	// const deleteFieldHandler = (sectionMappingId: string, fieldId: string) => {
	// 	const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));
	// 	delete tempCopy[sectionMappingId].fields[fieldId];
	// 	setConfigurationsDataCopy(tempCopy);
	// };

	const deleteFieldHandler = (sectionMappingId: string, fieldId: string) => {
		const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));

		// Delete the target field
		delete tempCopy[sectionMappingId].fields[fieldId];

		// Get all remaining fields and sort them by current priority (optional)
		const fieldsArray = Object.values(tempCopy[sectionMappingId].fields);

		// Reassign priority starting from 1
		fieldsArray
			.sort((a: any, b: any) => a.priority - b.priority) // optional: keep order
			.forEach((field: any, index: number) => {
				field.priority = index + 1;
			});

		// Reconstruct the fields object with reassigned priorities
		const updatedFields: Record<string, any> = {};
		fieldsArray.forEach((field: any) => {
			updatedFields[field.id] = field;
		});

		tempCopy[sectionMappingId].fields = updatedFields;

		setConfigurationsDataCopy(tempCopy);
	};

	//Active Inactive field handler
	const onChangeFieldStatus = (
		sectionMappingId: string,
		fieldId: string,
		flag: boolean
	) => {
		const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));
		tempCopy[sectionMappingId].fields[fieldId].isActive = flag;
		setConfigurationsDataCopy(tempCopy);
	};

	//Field Priority Changes
	const onChangeFieldPriority = (
		sectionMappingId: string,
		fieldId: string,
		newPriority: number
	) => {
		// const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));
		// tempCopy[sectionMappingId].fields[fieldId].priority = priority;
		// Object.values(tempCopy[sectionMappingId].fields).forEach((field: any) => {
		// 	if (field.priority >= priority && fieldId != field.id) {
		// 		field.priority = field.priority + 1;

		// 	}
		// });
		console.log(
			'sectionMappingId',
			sectionMappingId,
			'fieldId',
			fieldId,
			'newPriority',
			newPriority
		);
		const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));
		const fields = tempCopy[sectionMappingId].fields;

		// Get the current priority of the field
		const currentPriority = fields[fieldId].priority;

		// If the new priority is the same as the current one, do nothing
		if (newPriority === currentPriority) {
			return tempCopy;
		}

		// Update the target field's priority
		fields[fieldId].priority = newPriority;

		// Adjust priorities for other fields
		Object.values(fields).forEach((field: any) => {
			if (field.id !== fieldId) {
				if (currentPriority < newPriority) {
					// Moving the field down
					if (
						field.priority > currentPriority &&
						field.priority <= newPriority
					) {
						field.priority -= 1;
					}
				} else {
					// Moving the field up
					if (
						field.priority < currentPriority &&
						field.priority >= newPriority
					) {
						field.priority += 1;
					}
				}
			}
		});
		setConfigurationsDataCopy(tempCopy);
	};

	// For add the extra field
	// Updated addFieldHandler function for the main Configurations component
	const addFieldHandler = (sectionID: string) => {
		const tempCopy = JSON.parse(JSON.stringify(configurationsDataCopy));

		if (sectionID === '6') {
			// Ensure the section exists for indirect allocations
			if (!tempCopy[sectionID]) {
				tempCopy[sectionID] = {
					id: sectionID,
					type: 'allocationRates',
					fields: {},
					addMore: true,
					toolTip:
						'Define multiple allocations rates, each with its own Account, Customer, Class, Location and Rate.',
					placeHolder: 'Select values',
					errorMessage: 'Please complete all fields for allocation rates.',
					qbMappingValue: '',
					capMappingTitle: 'Allocation Rates',
				};
			}

			setFirstTimeSubmit(true);

			// Find the largest existing field ID to avoid conflicts
			let largestId = 0;
			const existingFields = tempCopy[sectionID].fields || {};

			for (const key in existingFields) {
				if (key.startsWith('f')) {
					const number = parseInt(key.slice(1));
					if (!isNaN(number) && number > largestId) {
						largestId = number;
					}
				}
			}

			const id = 'f' + Number(largestId + 1);

			// Create field structure specific to indirect allocations (section 6)
			const field = {
				id: id,
				label: "",
				account: null,
				customer: null,
				class: null,
				location: null,
				rate: 0, // Add rate field for indirect allocations
				editable: true,
				deletable: true,
				ratesLimited: false,
				isEditing: true, // Start in edit mode for new allocations
				isActive: true,
				priority: Object.keys(existingFields).length + 1,
			};

			// Add the new field to existing fields
			tempCopy[sectionID].fields = {
				...existingFields,
				[id]: field,
			};

			setConfigurationsDataCopy(tempCopy);
		} else {
			// Default logic for all other sections (unchanged)
			setFirstTimeSubmit(true);
			let largestId = 0;
			for (const key in tempCopy[sectionID].fields) {
				if (key.startsWith('f')) {
					const number = parseInt(key.slice(1));
					if (!isNaN(number) && number > largestId) {
						largestId = number;
					}
				}
			}
			const id = 'f' + Number(largestId + 1);

			const field = {
				id: id,
				label: '',
				value: null,
				creditValue: null,
				editable: true,
				deletable: true,
				ratesLimited: false,
				isEditing: true,
				isActive: true,
				priority: Object.keys(tempCopy[sectionID].fields).length + 1,
			};
			tempCopy[sectionID].fields = {
				...tempCopy[sectionID].fields,
				[id]: field,
			};
			setConfigurationsDataCopy(tempCopy);
		}
	};

	// for check is there add permission
	const isAddIntegrationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Configurations',
			permission: ['add'],
		}
	);

	// for check is there add permission
	const isEditIntegrationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Configurations',
			permission: ['edit'],
		}
	);

	// for check is there add permission
	const isDeleteIntegrationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Configurations',
			permission: ['delete'],
		}
	);

	const isJournalEntriesPermissionEdit = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Journals Entries',
			permission: ['edit'],
		}
	);

	const isJournalEntriesPermissionAdd = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Journals Entries',
			permission: ['add'],
		}
	);

	const initialFunction = () => {
		dispatch(classOptionsAction());
		dispatch(chartOfAccountAction());
		dispatch(customerOptionsAction());
		dispatch(customerAccountAction());
		dispatch(locationAction());
		dispatch(locationOptionsAction());
		if (status === false || isConnected === false) {
			toastText('Please Connect the QuickBooks company first', 'error');
			setSelectedSidebar('Integrations');
		}
	};

	// For initial fetch the class COA and customer
	useEffect(() => {
		initialFunction();
	}, [selectedCompanyDetails]);

	//   For cancel operation
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	//   For conform operation
	const handleOk = () => {
		setIsModalOpen(false);
	};

	//   For open the model
	const showModal = (sectionMappingId: string, fieldId: string) => {
		setSelectedDelete({
			sectionMappingId: sectionMappingId,
			fieldId: fieldId,
		});
		setIsModalOpen(true);
	};

	// For generate the mapping obj
	useEffect(() => {
		generateMappingObject();
	}, [qbClass, qbChartOfAccounts, qbCustomers, configurationsDataCopy, qbLocations]);

	useEffect(() => {
		handleInitialState();
		// console.log(
		// 	'configurationsData',
		// 	configurationsData,
		// 	configurationsDataCopy
		// );
	}, [configurationsData]);

	if (
		isLoading ||
		qbClassLoading ||
		qbChartOfAccountsLoading ||
		qbCustomersLoading ||
		qbLocationsLoading
	) {
		//return <Loader />;
	}

	const deleteHandler = () => {
		deleteFieldHandler(
			selectedItemDeleteData.sectionMappingId,
			selectedItemDeleteData.fieldId
		);
		setIsModalOpen(false);
	};

	const toFixedPercentageHandler = (value: number) => {
		setDecimalToFixedPercentage(value);
	};

	const toFixedAmountHandler = (value: number) => {
		setDecimalToFixedAmount(value);
	};

	const isExcludeEmployeeEnabled = useSelector(
		(state: any) => state.companies?.currentCompany?.isEmployeeExcludedInJournal
	);

	const isSummarizedJournalViewEnabled = useSelector(
		(state: any) =>
			state.companies?.currentCompany?.isSummarizedJournalView ?? false
	);

	const isTimeHoursDecimal = useSelector(
		(state: any) =>
			state.companies?.currentCompany?.isTimeHoursDecimal ?? false
	);

	// const handleExcludeEmployeeChange = (checked: boolean) => {
	// 	console.log('Toggle Value:', checked); // ✅ This is where you get the value
	// 	setIsExcludeEmployeeEnabled(checked);
	// };

	const handleExcludeEmployeeChange = async (checked: any) => {
		setUpdateExcludeEmployeeLoader(true);
		await dispatch(
			updateEmployeeExcludedFlag({
				companyId: selectedCompanyDetails.companyId,
				value: checked,
			})
		);
		setUpdateExcludeEmployeeLoader(false);
	};

	const handleSummarizedViewChange = async (checked: any) => {
		setUpdateSummarizedViewLoader(true);
		await dispatch(
			updateJournalSummarizedViewFlag({
				companyId: selectedCompanyDetails.companyId,
				value: checked,
			})
		);
		setUpdateSummarizedViewLoader(false);
	};

	const handleTimeHoursDecimalChange = async (value: boolean) => {
		setUpdateTimeHoursDecimalLoader(true);
		await dispatch(
			updateTimeHoursDecimalFlag({
				companyId: selectedCompanyDetails.companyId,
				isTimeHoursDecimal: value,
			})
		);
		setUpdateTimeHoursDecimalLoader(false);
	};

	// JSX code
	return (
		<>
			<div className={styles.configuration}>
				<TableActionHeader title="Configurations" />
				<div
					className={styles.configuration__wrapper}
					ref={configurationContainerRef}
				>
					{tabKey === '5' && (
						<h3
							className={styles['configuration__title']}
							style={{ display: 'flex', alignItems: 'center' }}
						>
							Company Settings
							<Tooltip
								title={
									<span
										style={{
											fontSize: '12px',
										}}
									>
										This setting is organization-wide and impacts your entire
										organization.
									</span>
								}
							>
								<InfoCircleOutlined
									style={{ marginLeft: 8, color: '#888', fontSize: 18 }}
								/>
							</Tooltip>
						</h3>
					)}

					{tabKey !== '5' && (
						<div className={styles['configuration__header']}>
							<ConfigurationHeader
								onChangePayPeriodId={(id: string | null) => {
									setPayPeriodId(id);
								}}
								closeDrawerByAnimation={closeDrawerByAnimation}
							/>
						</div>
					)}

					{configurationsDataCopy ? (
						// <div className={styles['configuration__settings']}>
						<>
							<Tabs
								activeKey={tabKey}
								onChange={(key) => setTabKey(key)}
								items={[
									{
										label: 'Default Mapping',
										key: '1',
										children: (
											<div
												className={
													styles['configuration__settings--configuration']
												}
												style={{ marginTop: '20px' }}
											>
												<ConfigurationSettings
													settingsData={configurationsDataCopy}
													qbSelectionObj={qbSelectionObj}
													settingsChangeHandler={settingsChangeHandler}
													isFirstTimeSubmit={isFirstTimeSubmit}
													deleteFieldHandler={deleteFieldHandler}
													addFieldHandler={addFieldHandler}
													onChangeFieldPriority={onChangeFieldPriority}
													showModal={showModal}
													indirectExpenseRate={indirectExpenseRate}
													onChangeFieldStatus={onChangeFieldStatus}
												></ConfigurationSettings>
											</div>
										),
									},
									{
										label: 'Allocation Settings',
										key: '2',
										children: (
											<div>
												<div
													className={
														styles['configuration__settings--allocation']
													}
													style={{ marginTop: '20px' }}
												>
													<AllocationSettings
														settingsData={configurationsDataCopy}
														payrollMethod={payrollMethod}
														changePayrollMethodHandler={
															changePayrollMethodHandler
														}
														indirectExpenseRate={indirectExpenseRate}
														changeExpenseRateAllocationHandler={
															changeExpenseRateAllocationHandler
														}
														settingsChangeHandler={settingsChangeHandler}
														qbSelectionObj={qbSelectionObj}
														addFieldHandler={addFieldHandler}
														deleteFieldHandler={deleteFieldHandler}
													/>
												</div>
												<div
													className={styles['configuration__settings--decimal']}
												>
													<DecimalSettings
														decimalToFixedAmount={decimalToFixedAmount}
														decimalToFixedPercentage={decimalToFixedPercentage}
														toFixedPercentageHandler={toFixedPercentageHandler}
														toFixedAmountHandler={toFixedAmountHandler}
													/>
												</div>
											</div>
										),
									},
									{
										label: 'Time Settings',
										key: '3',
										children: (
											<div style={{ marginTop: '20px' }}>
												<JournalSettings
													isClassRequiredForJournal={isClassRequiredForJournal}
													isCustomerRequiredForJournal={
														isCustomerRequiredForJournal
													}
													handleIsClassRequiredForJournal={(value) =>
														setIsClassRequiredForJournal(value)
													}
													handleIsCustomerRequiredForJournal={(value) =>
														setIsCustomerRequiredForJournal(value)
													}
												/>
											</div>
										),
									},
									{
										label: 'Custom Mapping',
										key: '4',
										children: (
											<div style={{ marginTop: '20px' }}>
												<CustomConfigurationMapping payPeriodId={payPeriodId} />
											</div>
										),
									},
									{
										label: 'Company Settings',
										key: '5',
										children: (
											<div
												className={styles['configuration__settings--company']}
												style={{ marginTop: '20px' }}
											>
												<CompanySettings
													isExcludeEmployeeEnabled={isExcludeEmployeeEnabled}
													onToggleExclude={handleExcludeEmployeeChange}
													isSummarizedJournalViewEnabled={isSummarizedJournalViewEnabled}
													onToggleSummarizedView={handleSummarizedViewChange}
													isExcludeEmployeeLoading={updateExcludeEmployeeLoader}
													isSummarizedJournalViewLoading={updateSummarizedViewLoader}
													isJournalEntriesPermissionAdd={
														isJournalEntriesPermissionAdd
													}
													isJournalEntriesPermissionEdit={
														isJournalEntriesPermissionEdit
													}
													isTimeHoursDecimal={isTimeHoursDecimal}
													onTimeHoursDecimalChange={handleTimeHoursDecimalChange}
													isTimeHoursDecimalLoading={updateTimeHoursDecimalLoader}
												/>
											</div>
										),
									},
								]}
							/>
							{(isAddIntegrationPermission ||
								isDeleteIntegrationPermission ||
								isEditIntegrationPermission) &&
								showSaveButtonsKeys.includes(tabKey) ? (
								<div
									className={styles['buttons-wrapper']}
									style={{ marginTop: '20px' }}
								>
									<SaveCancelButtons
										saveTitle="Save & Close"
										cancelTitle="Reset"
										loadingForSave={updateConfigurationLoader}
										loadingForCancel={false}
										saveHandler={saveConfigurationHandler}
										cancelHandler={cancelConfigurationHandler}
									/>
								</div>
							) : null}
						</>
					) : // </div>
						null}
				</div>
			</div>
			<ConfirmDelete
				handleCancel={handleCancel}
				handleOk={handleOk}
				isModalOpen={isModalOpen}
				deleteHandler={deleteHandler}
			/>
		</>
	);
};

export default Configurations;
